import {Injectable} from '@angular/core';

import {Http, Response} from '@angular/http';
import {AuthHttp, AuthConfig} from 'angular2-jwt';

import {Observable} from 'rxjs/Observable';
// import 'rxjs/add/observable/throw';

import {StoreService} from '../store/store.service';
import {CognitoAuthService} from '../auth/cognito.service';

@Injectable()
export class DeviceService {

    devices: any[ ] = [];

    maxDeviceDataCallRetries = 3;
    devicesDataSubscription;
    summarySubscription;

    idToken: string;
    customer: string;

    private static extractData(res: Response) {
        let body = res.json();
        return body || [];
    }

    private static handleError(error: any) {
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(errMsg); // log to console instead

        return Observable.throw(errMsg);
    }

    constructor(private store: StoreService, private http: Http, private authHttp: AuthHttp, private cognitoAuthService: CognitoAuthService) {
    }

    // This service retrieves the Device summary
    getDeviceSummary(params): Observable<any> {
        const self = this;
        /*
        let summary = [];
        return Observable.create(function (subscriber) {
            self.summarySubscription = self.getDevices(params).subscribe(function (devices) {
                // TODO: the device types below should be some global value
                // TODO: some more of the fields need to be better computed (like new, icon, name)
                const deviceTypes = ['iot', 'laptop', 'desktop', 'mobile', 'server', 'other'];
                deviceTypes.forEach(function (type) {
                    const s = {type: type, count: 0, name: type, icon: type, tooltip: type + ' detected', new: 1};
                    s.count = devices.filter(element => element.type === type).length;
                    if (type === 'iot') {
                        s.icon = 'wifi';
                    }
                    if (type === 'other') {
                        s.icon = 'question-circle-o';
                    }
                    summary.push(s);
                });
            }, function (err) {
                summary = [];
            });
            subscriber.next(summary);
        });
        */
        return self.getDevices(params).map(function (devices) {
            // TODO: the device types below should be some global value
            // TODO: some more of the fields need to be better computed (like new, icon, name)

            const summary = [];
            const deviceTypes = ['iot', 'laptop', 'desktop', 'mobile', 'server', 'other'];
            deviceTypes.forEach(function (type) {
                const s = {type: type, count: 0, name: type, icon: type, tooltip: type + ' detected', new: 1};
                s.count = devices.filter(element => element.type === type).length;
                if (type === 'iot') {
                    s.icon = 'wifi';
                }
                if (type === 'other') {
                    s.icon = 'question-circle-o';
                }
                summary.push(s);
            });
            return summary;
        });

    }

    // This service retrieves the Devices
    // example params = {timePeriod: 'w', deviceType = ''}
    getDevices(params): Observable<any> {

        const self = this;

        return Observable.create(function (subscriber) {

            let doFetchDevicesFromAPI = false;

            if (!self.store.isFresh()) {

                // console.log('Store is NOT FRESH!');
                self.store.delete('devicesParams');
                self.store.delete('devices');
                doFetchDevicesFromAPI = true;
            } else {

                const storeDevices = self.store.get('devices');
                const storeDevicesParams = self.store.get('devicesParams');

                let index = -1;
                const paramsPresent = storeDevicesParams.some(function (p) {
                    ++index;
                    return JSON.stringify(p) === JSON.stringify(params);
                });

                if ((storeDevices.length !== 0) && (paramsPresent)) {

                    const devices = storeDevices[index];

                    // console.log('events at index = ' + index);

                    if (devices == null) {

                        // console.log('events are NULL at index = ' + index, events);

                        doFetchDevicesFromAPI = true;
                    } else {

                        // console.log('Retrieving events from STORE');
                        // console.log('storeEvents = ', storeEvents);
                        // console.log('storeEventsParams = ', storeEventsParams);
                        // console.log('================');

                        subscriber.next(devices);
                    }
                } else {
                    doFetchDevicesFromAPI = true;
                }

            }

            // Fetch events from the API only if the events in the store on client are not fresh
            // i.e. if they are older than the life of the store
            if (doFetchDevicesFromAPI) {

                self.cognitoAuthService.getIdTokenPromise().then(function (idToken) {

                    self.idToken = idToken;
                    self.customer = self.cognitoAuthService.decodeToken(idToken)['custom:customer'];

                    self.devicesDataSubscription = self.callDevicesApi(params).subscribe(function (devices) {

                        devices.forEach(function (device) {
                            device.last_seen = device.last_seen.substring(0, 19).replace('T', ' ');

                            // [AT] Determine status based on last_seen value
                            // [TODO] This may be moved back to Lambda? Think about it
                            var diff = new Date().getTime() - new Date(device.last_seen).getTime();
                            device.age = '';
                            device.active = 0;
                            if (diff) {
                                var s = Math.floor(diff / 1000);
                                var m = Math.floor(s / 60);
                                s = s % 60;
                                var h = Math.floor(m / 60);
                                m = m % 60;
                                var days = Math.floor(h / 24);
                                h = h % 24;

                                if (days) device.age = days.toString() + ' days ago';
                                else if (h) device.age = h.toString() + ' hrs ago';
                                else if (m) device.age = m.toString() + ' mins ago';
                                else if (s) device.age = s.toString() + ' secs ago';
                                else device.age = 'inactive';

                                if (days > 1) device.active = 0;
                                else device.active = 1;
                            }

                            // extract vendor
                            device.vendor = '';
                            if (device.attributes) {
                                device.vendor = JSON.parse(device.attributes)['vendor'];
                            }

                            // determine data
                            device.sdata = device.rdata = '';
                            if ("sent" in device) {
                                device.sdata = self.convertBytes(device.sent);
                            }
                            if ("recv" in device) {
                                device.rdata = self.convertBytes(device.recv);
                            }

                            // determine activity
                            device.activity = '';
                            if (device.alerts) device.activity += device.alerts.toString() + ' alerts | ';
                            if (device.events) device.activity += device.events.toString() + ' events | ';
                            if (device.remote_hosts) device.activity += device.remote_hosts.toString() + ' remote conns';

                            device.last_seen = device.last_seen.replace(' ', 'Z');
                            device.last_seen = new Date(device.last_seen);
                            device.last_seen = device.last_seen.toLocaleDateString('en-US') + ' ' + device.last_seen.toLocaleTimeString('en-US', {hour12: false});

                            // [AT]: hard-code the type of device here.
                            //console.log(device.attributes);
                            let attr = device.attributes;
                            device.type = 'other';
                            if (attr) {
                                if (attr.includes('Apple')) device.type = 'mobile';
                                if (attr.includes('SAMSUNG')) device.type = 'mobile';
                                if (attr.includes('Nest')) device.type = 'iot';
                                if (attr.includes('VMware')) device.type = 'desktop';
                                if (attr.includes('Enphase')) device.type = 'iot';
                                if (attr.includes('Dell')) device.type = 'laptop';
                                if (attr.includes('Sonos')) device.type = 'iot';
                                if (attr.includes('Synology')) device.type = 'server';
                                if (attr.includes('YAMAHA')) device.type = 'iot';
                                if (attr.includes('Microsoft')) device.type = 'laptop';
                                if (attr.includes('Amazon')) device.type = 'iot';
                                if (attr.includes('Roku')) device.type = 'iot';
                                if (attr.includes('Private')) device.type = 'iot';
                                if (attr.includes('TP-LINK')) device.type = 'server';
                                if (attr.includes('Verizon')) device.type = 'other';
                                if (attr.includes('Hewlett')) device.type = 'laptop';
                                if (attr.includes('Intel')) device.type = 'desktop';
                                if (attr.includes('Hon')) device.type = 'iot';
                                if (attr.includes('Belkin')) device.type = 'iot';
                                if (attr.includes('CE')) device.type = 'iot';
                                if (attr.includes('Roku')) device.type = 'iot';
                            }
                            //if (device.attributes['vendor'] == 'Apple, Inc.') device.type = 'mobile';

                            // Add icon type as well
                            device.icon = device.type;
                            if (device.icon == 'iot') device.icon = 'wifi';
                            if (device.icon == 'other') device.icon = 'question-circle-o';
                        });

                        self.devices = devices;

                        // XXX: there is a race condition where multiple calls can be made to getDevices API before the API completes resulting in multiple adds - this needs to be resolved either where the API is called OR when these are added
                        self.store.add('devicesParams', params);
                        self.store.add('devices', devices);
                        self.store.refresh();

                        // console.log('Got fresh events from API');
                        // console.log('events', self.store.get('events'));
                        // console.log('eventsParams', self.store.get('eventsParams'));
                        // console.log('================');

                        subscriber.next(devices);

                    }, function (err) {

                        self.devices = [];

                        // Retry fetching events until max number of retries is reached
                        self.devicesDataSubscription.unsubscribe();
                        --self.maxDeviceDataCallRetries;
                        if (self.maxDeviceDataCallRetries > 0) {
                            self.getDevices(params);
                        }
                    });
                }).catch(function (err) {

                    console.log('Error in getIdTokenPromise()');
                    console.log(err);

                });
            }
        });
    }

    private callDevicesApi(params): Observable<any> {

        // TODO: Use params to fetch filtered events from AWS instead of fetching all events

        const json_token = {ip: params.ip};

        const apiConfig = this.store.get('apiConfig');
        apiConfig.headers["Authorization"] = this.idToken;

        // Mock request to a static events data file
        // return this.http.get('assets/data/devices.json').map(DeviceService.extractData).catch(DeviceService.handleError);
        return this.http.post(apiConfig.devicesURL,
            JSON.stringify(json_token), {headers: apiConfig.headers})
            .map(DeviceService.extractData)
            // .map(res => res.json())
            .catch(DeviceService.handleError);

    }

    private convertBytes(input: any): String {
        // determine data
        var data = '0 KB';
        if (input) {
            if (input < 1000) data = input.toString() + ' B';
            else if (input < 1000000) data = (input / 1000).toFixed(0) + ' KB';
            else if (input < 1000000000) data = (input / 1000000).toFixed(0) + ' MB';
            else if (input >= 1000000000) data = (input / 1000000000).toFixed(0) + ' GB';
        }
        return data;
    }
}



// WEBPACK FOOTER //
// /app/src/app/shared/device/device.service.ts